import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { theme } from '@/utils/theme';

export default createVuetify({
  components,
  directives,
  defaults: {
    // Vuetify 3's default input density/margins are far looser than v2 —
    // match the previous compact filter-list look
    VCheckbox: { density: 'compact', hideDetails: true },
    // v2 capped every tooltip at 300px via `.v-tooltip__content`. Vuetify 3
    // renders into `.v-overlay__content` and writes its own max-width inline
    // while positioning, so the cap belongs here rather than in a stylesheet.
    VTooltip: { maxWidth: 300 },
    VRadio: { density: 'compact' },
    VRadioGroup: { density: 'compact', hideDetails: true }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
  display: {
    thresholds: {
      sm: 768
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: theme.color,
          secondary: '#299FFF',
          danger: '#F6595D',
          third: '#7673FF',
          fourth: '#FF7F6C',
          error: '#ff7f6b',
          text: '#343439',
          light: '#979797',
          lightBg: '#f6f6f6',
          border: '#dbdbdb'
        }
      }
    }
  }
});
